import { ViewModel,View, Component, ObservableArray } from "binder"
import  { FilesListView } from "./filesList-view"
import { FileSelectorViewModel, IFileDownloader } from "../fileSelector/fileSelector-viewModel";
import { getAsBoolean, getAsNumber } from "../utilities";
import { FileChooser, stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class FilesListViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        
        this.items = ObservableArray.create<fileWrapper>();
        this.downloader = new defaultDownloader();
    }
    GetDefaultView(): View <ViewModel> {
        return new FilesListView();
    }
    public getTypeId(): string {
        return "VM-F6190D18-C2EB-490A-9D4D-F0761B21E8D6"
    }

    public set isreadonly(v: boolean) { this._isreadonly = getAsBoolean(v); this.updateChildrenInfo(); } public get isreadonly(): boolean { return this._isreadonly;} private _isreadonly: boolean;
    public set issingle(v: boolean) { this._issingle = getAsBoolean(v); this.updateChildrenInfo(); this.updateSingleFile();} public get issingle(): boolean { return this._issingle;} private _issingle: boolean;
    public set downloader(v: IFileDownloader) { this._downloader = v;this.updateChildrenInfo(); } public get downloader(): IFileDownloader { return this._downloader;} private _downloader: IFileDownloader;
    public set singlemaxsize(v: number) { this._singlemaxsize = getAsNumber(v,true);this.updateChildrenInfo(); } public get singlemaxsize(): number { return this._singlemaxsize;} private _singlemaxsize: number;
    public set items(v: ObservableArray<fileWrapper>) { this._items = v; } public get items(): ObservableArray<fileWrapper> { return this._items;} private _items: ObservableArray<fileWrapper>;
    
    public set fulldata(v: any) { 
        this._fulldata = v; 
        if(this.isUpdating===true){
            return;
        }else{
            this.updateFromFullData();
        }
    
    } public get fulldata(): any { return this._fulldata;} private _fulldata: any;
    private isUpdating:boolean;
    async add(){
        let chooser = new FileChooser();
        chooser.maxsize = this.singlemaxsize;
        let result = await chooser.chooseFile();
        if(result.isChoosed){
            let selector = new fileWrapper(this);
            selector.fileSelector.filename = result.filename;
            selector.fileSelector.filecontent = result.fileContent;
            selector.updateFileSelectorInfoFromParent();
            if(this.issingle){
                this.items.update(...[selector]);
            }else{
                this.items.push(selector);
            }
        }
        this.updateFullData();
    }
    remove(wrapper:fileWrapper){
        this.items.remove(wrapper);
        this.updateFullData();
    }

    updateFullData(){
        this.isUpdating = true;
        this.fulldata = this.items.map(x=>{
            let r : any = {};
            if(stringIsNullOrEmpty(x.fileInfoId)){
                r.fileContent= x.fileSelector.filecontent;
                r.fileName= x.fileSelector.filename;
            }else{
                r.fileInfoId= x.fileInfoId;
                r.fileContentId= x.fileSelector.fileid;
                r.fileContent= x.fileSelector.filecontent;
                r.fileName= x.fileSelector.filename;
            }
            return r;
        });
        this.isUpdating = false;
    };
    updateFromFullData(){
        if(this.fulldata==null || (typeof this.fulldata === 'string' && stringIsNullOrEmpty(this.fulldata))){
            this.items.clear();
        }else{
            this.items.update(...this.fulldata.map(x=>{
                let r = new fileWrapper(this);
                r.fileSelector.filename = x.fileName;
                r.fileSelector.fileid = x.fileContentId;
                r.fileInfoId = x.fileInfoId;
                r.updateFileSelectorInfoFromParent();
                return r;
            }));
        }
    }

    updateChildrenInfo(){
        this.items.forEach(x=>x.updateFileSelectorInfoFromParent());
    }

    updateSingleFile(){
        if(this.items.length<=1)
            return;
        this.items.update(...[this.items[0]]);
        this.updateFullData();
    }
}

export class fileWrapper extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    
    constructor(parent:FilesListViewModel) {
        super(parent);
        this._typedParent = parent;
        this.fileSelector = new FileSelectorViewModel(this);        
    }
    
    public set fileInfoId(v: string) { this._fileInfoId = v; } public get fileInfoId(): string { return this._fileInfoId;} private _fileInfoId: string;
    public set readonly(v: boolean) { this._readonly = v; } public get readonly(): boolean { return this._readonly;} private _readonly: boolean;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    private _typedParent : FilesListViewModel;
    
    updateFileSelectorInfoFromParent(){
        this.fileSelector.downloader = this._typedParent.downloader;
        this.fileSelector.isreadonly = true;
        this.fileSelector.maxsize = this._typedParent.singlemaxsize;
        this.readonly = this._typedParent.isreadonly;
    }

    remove(){
        this._typedParent.remove(this);
    }
}

class defaultDownloader implements IFileDownloader{
    async download(fileId: string, filename: string): Promise<{ name: string; content: string; }> {
        let serverResult =await ServerConnection.callServer('/Complex/BpmsServices/GetFileContent',{
            FileContentId : fileId
        });
        return {
            name : filename,
            content : serverResult.Data
        };
    }

}